import(/* webpackMode: "eager" */ "/private/tmp/statura-proddeploy-l6lpgk/apps/web/src/app/(auth)/error.tsx");
